var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3596 0.0554251C51.8295 -1.30509 67.6364 24.0499 56.1967 44.6638C45.6771 63.6422 18.6641 65.3875 5.83733 47.8245C-8.25285 28.5163 4.65628 1.42968 28.3596 0.0554251Z",
    fill: "#00B900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.526 19.3355C43.5061 18.827 45.3876 21.5343 44.0142 24.1728L28.1113 40.1417C26.8341 41.1174 25.2685 41.0625 24.0326 40.073C21.7803 37.4756 18.6217 35.1257 16.4656 32.5146C13.7876 29.2851 17.2759 25.4097 20.6817 27.6222L25.9003 32.8581L26.2848 32.9681L39.3587 19.9264C39.6746 19.679 40.1415 19.4179 40.526 19.363V19.3355Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.04d1c6a1e8e825c9500e028ec53ea566.svg";
export { ForwardRef as ReactComponent };